import React, { useCallback, useEffect, useRef, useState } from "react";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "src/components/ComponentesFormularios/ImagePicker";
import TransfertList from "../../../components/TransferList";
import AutocompleteForm from "src/components/ComponentesFormularios/Autocomplete";
import { ConstantsFormCrud } from "../../../data/RoutesFormCrud";
import { alertQuestionService } from "../../../services/alertQuestionService";
import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco,
    validArray
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidthHeader,
    classResponsiveFormDoubleWidthHeaderWithoutPaddingX,
    classResponsiveFormWithoutPaddingX,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados,
    optionsYesNo
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { crearActivosService } from "src/services/apiCrearActivos";
import { preciosService } from "src/services/apiPrecios";

const DatosBasicos = React.memo(({ isEditing, isAddMode, properties, stateSelects }) => {

    console.log(stateSelects)
    console.log(properties)

    const { control, formState: { errors } } = useFormContext();
    let msgTitle = ''

    if(isAddMode == false && isEditing == false){
        msgTitle = 'Visualizar'
    }else if(isAddMode == false && isEditing == true){
        msgTitle = 'Editar'
    }else{
        msgTitle = 'Crear'
    }


    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="mt-3 p-2 bg-white" style={{ border: '1px solid #C6C6C6', borderRadius: 5 }}>
                
                <h4>{`${msgTitle} Registro de Regla de Precio`}</h4>

                <hr className="m-0 p-0" />

                <div className="row mx-1 align-items-center justify-content-between mt-3">
                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="nivel" label="Nivel"
                        options={stateSelects?.arrTipoNivel} multiple={true} required={false} className={`${classResponsiveForm}`}
                        customError={null} />

                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="oficinaVentas" label="Oficina de Ventas"
                        options={stateSelects?.arrOficinaVentas} required={false} className={`${classResponsiveForm}`} multiple={false}
                        customError={errors.oficinaVentas ? ERRORFIELDREQUIRED : null} />

                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="agenteComercial" label="Agente comercial"
                        options={stateSelects?.arrAgenteComercial} required={false} className={`${classResponsiveForm}`}
                        multiple={true}
                        customError={null} />

                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="canal" label="Canal"
                        options={stateSelects?.arrCanal} required={false} className={`${classResponsiveForm}`}
                        multiple={true}
                        customError={null} />

                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="subCanal" label="SubCanal"
                        options={stateSelects?.arrSubCanal} required={false} className={`${classResponsiveForm}`}
                        multiple={true}
                        customError={null} />

                    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={true} showId={true} identificador="tipologia" label="Tipología"
                        options={stateSelects?.arrTipologia} required={false} className={`${classResponsiveForm}`}
                        multiple={true}
                        customError={null} />

                </div>

                <div className="row mx-1 align-items-center justify-content-between mt-2">

                    <div style={{ width: '40%' }}>
                        {/*    <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={isAddMode} showId={true} identificador="producto" label="Producto"
                              options={[properties?.producto]}   required={true} className={`w-100 px-2`} multiple={false} customError={null} />
                               */}
                        <InputForm inputProps={{ control }} identificador="producto" label="Producto" readOnly={!isEditing}
                            placeholder="" required={true} type="text" className={`w-100 px-2`} rules={{ min: 1 }} disabled={true}
                           /*  customError={errors.precio ? ERRORFIELDREQUIRED : null} */ />
                    </div>

                    <div style={{ width: '60%' }}>
                        <InputForm inputProps={{ control }} identificador="precio" label="Precio" readOnly={!isEditing}
                            placeholder="" required={true} type="number" className={`${classResponsiveFormWidthHeader}`} /* rules={{ min: 1 }} */
                            customError={errors.precio ? ERRORFIELDREQUIRED : null} />

                        <CalendarFormRange inputProps={{ control }} disabled={!isEditing} disabledInit={!isAddMode} identificador="dtVigencia" required={true} label="Fecha Inicio - Fecha Fin"
                            className={`${classResponsiveFormDoubleWidthHeaderWithoutPaddingX}`} readOnly={true}
                            customError={errors.dtVigencia ? ERRORFIELDREQUIRED : null} />
                    </div>

                </div>
            </div>
        </div>
    )
})

const externalAction = (tableRef, aux) =>{


            modalCRUDService.showModal({
                props: {
                    data: aux,
                    referencia: tableRef
                },
                type: ConstantsFormCrud.modalTableExcel,
                title: `Tabla Excel`,
                // isAddMode: true,
                // isEditable: true,
                dense: true,
                id: modalCRUDService.defaultId,
                size: `xl`
            });
}

const FormPrecioCRUD = ({ isEditing, properties, isAddMode }) => {

    const [stateSave, setStateSave] = useState(false)
    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const generalServicesState = useSelector(state => state.generalServices)
    const methods = useForm({
        defaultValues: {
            ...data,
            dtVigencia: getFechaToCalendarRange(data?.dtVigenciaIni ? data?.dtVigenciaIni : dateToStringFormat(new Date()), data?.dtVigenciaFin ? data?.dtVigenciaFin : '2200-12-31'),
            //dtVigencia: getFechaToCalendarRange(dateToStringFormat(new Date()), dateToStringFormat(new Date(2099,12,31))),
        }
    });
    const { register, handleSubmit, formState: { errors }, control } = methods;

    const onSuccessSubmit = (data) => {
        let message = {}
        if(isAddMode){
            message.title = "Guardar Regla"
            message.quest = "¿Estás seguro de crear la regla?"
            message.msg = "Sí desea guardar la regla de clic en el botón Aceptar"
        }else{
            message.title = `Actualizar Regla #${params.node.id}`
            message.quest = "¿Estás seguro de actualizar la regla?"
            message.msg = "Sí desea guardar los cambios efectuados en el registro de clic en el botón Aceptar"
        }

        handleSaveData(data, message)
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    const handleSaveData = (data, message) => {

        alertQuestionService.showAlert({
            title: `${message.title}`, question: `${message.quest}`,
            message: `${message.msg}`,

            actionBtnAceptar: () => {

                alertQuestionService.clear();
                data.dtValidoInicial = dateToStringFormat(data.dtVigencia[0]);
                data.dtValidoFinal = dateToStringFormat(data.dtVigencia[1]);
                data.idUsrAuditoria = idUsuario;
                data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

                preciosService.crudPrecios(data).then(
                    response => {

                        const { status, msg, data: datos } = response;
                        const aux = datos?.data

                        if (status) {
                            if(datos?.validacion){
                                externalAction(tableRef, aux)
                            }else{
                                if (datos?.data.idmsg === 200) {
                                    if (isAddMode) {

                                        tableRef.current.api.applyTransaction({
                                            add: [{
                                                id: datos?.data.idreg,
                                                idNivel: data?.nivel.id,
                                                nivel: data.nivel.text.split("-")[0],
                                                idOficina: data?.oficinaVentas != '' ? data?.oficinaVentas.id : '',
                                                oficina: data?.oficinaVentas != '' ? data?.oficinaVentas.text.split("-")[0] : '',
                                                idAgente: data?.agenteComercial != '' ? data?.agenteComercial.id : '',
                                                agente: data?.agenteComercial != '' ? data?.agenteComercial.text : '',
                                                idCanal: data?.canal != '' ? data?.canal.id : '',
                                                canal: data?.canal != '' ? data?.canal.text.split("-")[0] : '',
                                                idSubCanal: data?.subCanal != '' ? data?.subCanal.id : '',
                                                subCanal: data?.subCanal != '' ? data?.subCanal.text.split("-")[0] : '',
                                                idTipologia: data?.tipologia != '' ? data?.tipologia.id : '',
                                                tipologia: data?.tipologia != '' ? data?.tipologia.text.split("-")[0] : '',
                                                idProducto: data?.producto.id,
                                                producto: data?.producto.text,
                                                precio: data?.precio,
                                                dtValidoInicial: data?.dtValidoInicial,
                                                dtValidoFinal: data?.dtValidoFinal,
                                                auditor: data?.idUsrAuditoria,
                                                fechaAuditoria: new Date().toISOString().slice(0,10) + ' '+ new Date().toTimeString().slice(0,8), 
                                            }]
                                        })

                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.data.txmsg } });

                                    }
                                    else {
                                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.data.txmsg } });

                                        const rowNode = params.api.getRowNode(params.node.id);

                                        rowNode.setDataValue("idNivel", data?.nivel.id);
                                        rowNode.setDataValue("nivel", data?.nivel.text.split("-")[0]);
                                        rowNode.setDataValue("idOficina", data?.oficinaVentas != '' ? data?.oficinaVentas.id : '');
                                        rowNode.setDataValue("oficina", data?.oficinaVentas != '' ? data?.oficinaVentas.text.split("-")[0] : '');
                                        rowNode.setDataValue("idAgente", data?.agenteComercial != '' ? data?.agenteComercial.id : '');
                                        rowNode.setDataValue("agente", data?.agenteComercial != '' ? data?.agenteComercial.text : '');
                                        rowNode.setDataValue("idCanal", data?.canal != '' ? data?.canal.id : '');
                                        rowNode.setDataValue("canal", data?.canal != '' ? data?.canal.text.split("-")[0] : '');
                                        rowNode.setDataValue("idSubCanal", data?.subCanal != '' ? data?.subCanal.id : '');
                                        rowNode.setDataValue("subCanal", data?.subCanal != '' ? data?.subCanal.text.split("-")[0] : '')
                                        rowNode.setDataValue("idTipologia", data?.tipologia != '' ? data?.tipologia.id : '');
                                        rowNode.setDataValue("tipologia", data?.tipologia != '' ? data?.tipologia.text.split("-")[0] : '');
                                        rowNode.setDataValue("idProducto", data?.producto.split('-')[0]);
                                        rowNode.setDataValue("producto", data?.producto.split('-')[1]);
                                        rowNode.setDataValue("precio", data?.precio);
                                        rowNode.setDataValue("dtValidoInicial", data?.dtValidoInicial);
                                        rowNode.setDataValue("dtValidoFinal", data?.dtValidoFinal);
                                        rowNode.setDataValue("auditor", data?.idUsrAuditoria); 
                                        rowNode.setDataValue("fechaAuditoria", new Date().toISOString().slice(0,10) + ' '+ new Date().toTimeString().slice(0,8)); //Formato fecha y hora
                                    }

                                    modalCRUDService.clear();
                                }
                                else {
                                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.data.txmsg } });
                                }
                            }


                        } else {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                        }
                    },
                    error => {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
                    }
                );
                    
                },
                actionBtnCancelar: () => alertQuestionService.clear(),
                type: GlobalConstants.alertInfo
            })
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-end ">

                    <div className="d-flex justify-content-end align-items-center">
                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={data} stateSelects={generalServicesState} isAddMode={isAddMode} />
        </FormProvider>
    )

}

export default FormPrecioCRUD;
